import { fragments } from '@/gql'
const {gql} = require('graphql-tag');
export default gql`
  mutation mergeFilm($id: ID!, $targetID: ID!) {
    mergeFilm (id: $id, targetID: $targetID) {
      ...dupCheckResultDetail
    }
  }
  ${fragments.dupCheckResultDetail}
`;
